<h2>
  {{ translationService.getIngredientsText() }}
</h2>
@if (ingredients.length) {
  <mat-nav-list>
    @for (
      ingredient of ingredients;
      track ingredient;
      let i = $index;
      let last = $last
    ) {
      <a
        mat-list-item
        (keydown)="onKeydown($event, i)"
        [attr.tabindex]="i === 0 ? 0 : -1"
        [ngClass]="{
          valid: ingredient.validationStatus === validationStatuses.VALID,
          invalid: ingredient.validationStatus === validationStatuses.INVALID,
        }"
      >
        <span matListItemTitle>
          <span class="bold"
            >{{ translationService.getIngredientNameText() }}:</span
          >
          {{ ingredient.ingredientName }}
        </span>
        <span matListItemLine>
          <span class="bold"
            >{{ translationService.getUpperConcentrationText() }}:</span
          >
          {{ ingredient.upperConcentration }}
        </span>
        <span matListItemLine>
          <span class="bold"
            >{{ translationService.getLowerConcentrationText() }}:</span
          >
          {{ ingredient.lowerConcentration }}
        </span>
        <span matListItemLine>
          <span class="bold"
            >{{ translationService.getDoesNotContainText() }}:</span
          >
          {{ getSymbolForFlag(ingredient.doesNotContain) }}
        </span>
        <span matListItemLine>
          <span class="bold"
            >{{ translationService.getMayContainText() }}:</span
          >
          {{ getSymbolForFlag(ingredient.mayContain) }}
        </span>
        <span matListItemLine>
          <span class="bold"
            >{{ translationService.getOptionallyDisclosedText() }}:</span
          >
          {{ getSymbolForFlag(ingredient.optionallyDisclosed) }}
        </span>
        <span matListItemLine>
          <span class="bold"
            >{{ translationService.getComplianceOfficerText() }}:</span
          >
          {{ getSymbolForFlag(ingredient.complianceOfficer) }}
        </span>
        <span matListItemLine>
          <span class="bold"
            >{{ translationService.getWasteHandlerText() }}:</span
          >
          {{ getSymbolForFlag(ingredient.wasteHandler) }}
        </span>
        <span matListItemLine>
          <span class="bold">{{ translationService.getConsumerText() }}:</span>
          {{ getSymbolForFlag(ingredient.consumer) }}
        </span>
        <span matListItemLine>
          <span class="bold"
            >{{ translationService.getProductIdentifierText() }}:</span
          >
          {{ ingredient.productIdentifier }}
        </span>
      </a>
      @if (!last) {
        <mat-divider></mat-divider>
      }
    }
  </mat-nav-list>
} @else {
  <span>{{ translationService.getNoIngredientsFoundText() }}</span>
}
